// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__V5x9T","tyre":"style_tyre__ZiH1l"};